import { gql } from '@apollo/client';

export const GET_DIAGNOSTICS_QUERY = gql`
  query getDiagnostics($doRefresh: Boolean) {
    getDiagnostics(doRefresh: $doRefresh) {
      name
      isOK
    }
  }
`;

export const REBOOT_MODEM = gql`
  mutation rebootModem {
    rebootModem {
      rebootSuccess
    }
  }
`;

export const GET_MODEM_STATUS = gql`
  query getModemStatus($refetchData: Boolean) {
    getModemStatus(refetchData: $refetchData) {
      isOnline
    }
  }
`;

export const GET_FIBER_SERVICE_SUB_TYPE = gql`
  query getFiberServiceSubType {
    getFiberServiceSubType {
      ontMode
    }
  }
`;

export const UPDATE_SERVICE_SUB_TYPE = gql`
  mutation updateServiceSubType($input: UpdateServiceSubTypeInput!) {
    updateServiceSubType(input: $input) {
      status
      commandId
      error
    }
  }
`;

export const GET_SSID_INFO = gql`
  query getSsidInfo($productInstanceId: ID!) {
    getSsidInfo(productInstanceId: $productInstanceId) {
      ssid
    }
  }
`;

export const UPDATE_WIFI_INFO = gql`
  mutation updateSsidInfo($input: UpdateSsidInfoInput!) {
    updateSsidInfo(input: $input) {
      status
      newSsid
      newPassphrase
    }
  }
`;
